import { createSlice } from '@reduxjs/toolkit';
import { type SquaresAlert } from 'types/squares.type';

export interface SquaresAlertState {
  notifications: SquaresAlert[];
  isLoading: boolean;
}

const initialState: SquaresAlertState = {
  notifications: [],
  isLoading: false,
};

export const squaresAlertSlice = createSlice({
  name: 'squaresAlert',
  initialState,
  reducers: {
    appendAlerts(state, { payload }) {
      state.notifications = payload;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
    acknowledgeAlert(state, { payload }) {
      const alert = state.notifications.find(
        (n) => n.notificationID === payload
      );

      if (alert) {
        alert.acknowledged = true;
      }
    },
  },
});

export const { appendAlerts, setIsLoading, acknowledgeAlert } =
  squaresAlertSlice.actions;

export default squaresAlertSlice.reducer;
